import { loyallFunds } from '@/config';

const loyallFundIds = loyallFunds.map((item) => item.houseFundId);

export default {
  isLoading: ({ loadingCount }) => loadingCount > 0,
  hasError: ({ requestError }) => requestError instanceof Error,
  hasRequested: ({ lastResponseDate }) => lastResponseDate instanceof Date,
  hasResults: ({ results }) => results.length > 0,

  activeHouseFunds: ({ results }) => results.filter((item) => !item.endDate),
  externalHouseFunds: (state, { activeHouseFunds }) => activeHouseFunds.filter(
    (item) => !loyallFundIds.includes(item._id),
  ),
};
